import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false,
      error: null,
      errorInfo: null
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    const { boundaryName, onError } = this.props;
    
    console.group(`🔴 Error Boundary: ${boundaryName || 'Unknown'}`);
    console.error('Error:', error);
    console.error('Error Message:', error?.message);
    console.error('Error Stack:', error?.stack);
    console.error('Component Stack:', errorInfo?.componentStack);
    console.groupEnd();

    this.setState({
      error,
      errorInfo
    });

    if (onError) {
      onError(error, errorInfo, boundaryName);
    }
  }

  render() {
    if (this.state.hasError) {
      const { fallback, boundaryName, showDetails = true } = this.props;
      
      if (fallback) {
        return fallback;
      }

      return (
        <div style={{
          padding: '20px',
          margin: '20px',
          border: '2px solid #d90429',
          borderRadius: '8px',
          backgroundColor: '#fff5f5'
        }}>
          <h3 style={{ color: '#d90429', marginTop: 0 }}>
            ⚠️ Error in {boundaryName || 'Component'}
          </h3>
          {showDetails && (
            <>
              <p style={{ fontWeight: 'bold' }}>
                {this.state.error?.toString()}
              </p>
              <details style={{ marginTop: '10px' }}>
                <summary style={{ cursor: 'pointer', fontWeight: 'bold' }}>
                  Error Details
                </summary>
                <pre style={{
                  padding: '10px',
                  backgroundColor: '#f0f0f0',
                  borderRadius: '4px',
                  overflow: 'auto',
                  fontSize: '12px'
                }}>
                  {this.state.error?.stack}
                </pre>
              </details>
              <details style={{ marginTop: '10px' }}>
                <summary style={{ cursor: 'pointer', fontWeight: 'bold' }}>
                  Component Stack
                </summary>
                <pre style={{
                  padding: '10px',
                  backgroundColor: '#f0f0f0',
                  borderRadius: '4px',
                  overflow: 'auto',
                  fontSize: '12px'
                }}>
                  {this.state.errorInfo?.componentStack}
                </pre>
              </details>
            </>
          )}
          <button
            onClick={() => window.location.reload()}
            style={{
              marginTop: '15px',
              padding: '10px 20px',
              backgroundColor: '#d90429',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Reload Page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;

